/**
 * TileFooterSlot - Renders controls in the tile-footer location.
 *
 * This slot appears below each individual tile (in the caption area) and is
 * typically used for per-tile controls or metadata like captions.
 */

import React from 'react';

import {CaptionControl} from '../../controls';
import {ControlDefinition, GridCell} from '../types';

export type TileFooterSlotProps = {
  controls: ControlDefinition[];
  cell: GridCell;
};

/**
 * Renders controls in the tile-footer location.
 *
 * Currently renders captions. Future: can render per-tile controls here.
 *
 * @param props - Tile footer slot props
 * @returns Rendered tile footer or null if no content
 */
export const TileFooterSlot: React.FC<TileFooterSlotProps> = ({
  controls,
  cell,
}) => {
  if (cell.isEmpty) {
    return null;
  }

  // Find the caption control (type 'label' with control 'caption')
  const captionControl = controls.find(
    c => c.type === 'label' && c.control === 'caption'
  );

  // Future: Render per-tile controls from controls array
  const hasOtherControls = controls.some(
    c => c.type !== 'label' || c.control !== 'caption'
  );

  // Only render footer if there's actual content (captions or controls)
  // This prevents empty divs from affecting layout when there are no captions
  if (!captionControl && !hasOtherControls) {
    return null;
  }

  return (
    <div className="tile-footer">
      {captionControl && <CaptionControl cell={cell} />}
      {hasOtherControls && (
        <div className="tile-footer-controls break-words">
          {/* Future: Render per-tile controls here */}
        </div>
      )}
    </div>
  );
};
